import React from 'react';
import initializeFirebase from './initializeFirebase';

const DefaultLoading = () => <div>loading</div>;

export class FirestorePersistGate extends React.PureComponent {
  state = {
    persistEnabled: false,
    authorized: false,
  };

  _unregisterAuthStateChangeListener = null;
  componentDidMount() {
    let { firebase } = this.props;

    this._unregisterAuthStateChangeListener = firebase
      .auth()
      .onAuthStateChanged((user) => {
        if (user) this.setState({ authorized: true });
        else
          firebase
            .auth()
            .signInAnonymously()
            .catch((e) => {
              console.log(e);
            });
      });
  }

  UNSAFE_componentWillMount() {
    this.props.firebase
      .firestore()
      .enablePersistence()
      .then(() => this.setState({ persistEnabled: true }));
  }

  render() {
    const { children, Loading = DefaultLoading } = this.props;
    const { persistEnabled, authorized } = this.state;
    return persistEnabled && authorized ? children : <Loading />;
  }
}
